import { render, staticRenderFns } from "./OrdersForm.vue?vue&type=template&id=575774fa&scoped=true&"
import script from "./OrdersForm.vue?vue&type=script&lang=js&"
export * from "./OrdersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575774fa",
  null
  
)

export default component.exports